// componentes react bootstrap
import { useState, useEffect } from "react";
import { Form, Button, Modal, Container } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MdOutlineFileCopy } from "react-icons/md";
import { AiOutlinePicture } from "react-icons/ai";
// componentes
import { DropZoneFile } from "../DropZoneFile";
import CategoriaNoticia from "../../combos/CategoriaNoticia";
import { DatePickerInput } from "../../../common/DatePickerInput";
import GruposSubgrupos from "../../combos/GruposSubgrupos";
import { usePermisions } from "../../../../hooks/usePermisions";

//(httt-request)
import setDatos from "../../../../services/setDatos";
import updateDatos from "../../../../services/updateDatos";
import setDatosGrupos from "../../../../services/grupos/setDatos";
import { convertirFechaDate, limpiarTexto } from "../../../../helpers/utils";

// variables entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../../../environment";

export default function AdminNoticia({
  caractFiltro,
  idComponente,
  show,
  onHide,
  tituloModal,
  accion,
  objectEditarNoticia = null,
  buscar,
  handleLoad,
}) {
  const MySwal = withReactContent(Swal);
  const { permissions, infoUser } = usePermisions(idComponente);
  const [rutaImgImage, setRutaImgImage] = useState(null);
  const [fileUpload, setFileUpload] = useState(null);
  const [imageUpload, setImageUpload] = useState(null);
  const [tipofiltroSubGruposFiltrada, setTipofiltroSubGruposFiltrada] =
    useState([]);
  const [dataNoticia, setDataNoticia] = useState({
    idNoticia: "",
    nombreNoticia: "",
    descripcionNoticia: "",
    fechaNoticia: "",
    categoriaNoticia: "-1",
    activoNoticia: false,
    destacadoNoticia: false,
    calificacionNoticia: false,
    grupos: [],
    subgrupos: [],
  });

  useEffect(() => {
    if (accion === "Editar" && objectEditarNoticia) {
      let datosGrupo = [];
      let datosSubGrupo = [];
      let valorRecorrer = permissions.superAdmin
        ? caractFiltro.resultGruposSubGruposSuperAdmin
        : caractFiltro.resultGruposSubGrupos;

      let idGrupoArray = objectEditarNoticia.id_grupo.split(",");
      valorRecorrer.map((item) => {
        if (idGrupoArray.includes(item.id_grupo)) {
          datosGrupo.push({ value: item.id_grupo, label: item.nombre });
        }
      });
      caractFiltro.resultSubGruposForm.map((item) => {
        if (idGrupoArray.includes(item.id_grupo)) {
          datosSubGrupo.push({ value: item.id_grupo, label: item.nombre });
        }
      });
      setDataNoticia({
        idNoticia: objectEditarNoticia.id_noticia,
        nombreNoticia: objectEditarNoticia.nombre,
        descripcionNoticia: objectEditarNoticia.descripcion,
        fechaNoticia: convertirFechaDate(objectEditarNoticia.fecha_registro),
        categoriaNoticia: objectEditarNoticia.fk_id_categoria_noticia,
        activoNoticia: objectEditarNoticia.activo,
        destacadoNoticia: objectEditarNoticia.portada,
        calificacionNoticia: objectEditarNoticia.calificable,
        grupos: datosGrupo,
        subgrupos: datosSubGrupo,
      });

      setRutaImgImage(
        `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Noticias/${objectEditarNoticia.id_noticia}/${objectEditarNoticia.imagen}`
      );
    } else {
      setDataNoticia({
        idNoticia: "",
        nombreNoticia: "",
        descripcionNoticia: "",
        fechaNoticia: "",
        categoriaNoticia: null,
        activoNoticia: false,
        destacadoNoticia: false,
        calificacionNoticia: false,
        grupos: [],
        subgrupos: [],
      });
    }
  }, [objectEditarNoticia, show, accion]);

  const handleFileUpload = (file) => {
    setFileUpload(file);
  };

  const handleImageUpload = (file) => {
    setImageUpload(file);
  };

  const handleChange = ({ target }) => {
    // console.log(target.type);
    if (target.type === "text" || target.type === "textarea") {
      setDataNoticia((prev) => ({
        ...prev,
        [target.name]: limpiarTexto(target.value),
      }));
    } else {
      setDataNoticia((prev) => ({
        ...prev,
        [target.name]:
          target.type === "checkbox" ? target.checked : target.value,
      }));
    }
  };

  const handleDateChange = (date) => {
    setDataNoticia((prev) => ({
      ...prev,
      fechaNoticia: date,
    }));
  };

  const handleChangeGrupos = ({ nombreCombo, valor, tipo }) => {
    if (tipo === "1") {
      let valorComparar = valor.map((val) => val.value);
      let resultSubGruposcp = caractFiltro.resultSubGruposForm.filter((item) =>
        valorComparar.includes(item.id_grupo_padre)
      );
      setTipofiltroSubGruposFiltrada(resultSubGruposcp);
      let dataNoticiacp = { ...dataNoticia };
      dataNoticiacp.subgrupos = dataNoticia.subgrupos.filter((item) =>
        valorComparar.includes(item.value_parent)
      );
      dataNoticiacp[nombreCombo] = valor;
      setDataNoticia(dataNoticiacp);
    } else {
      setDataNoticia({
        ...dataNoticia,
        [nombreCombo]: valor,
      });
    }
  };

  const saveFile = async (id) => {
    try {
      let formData = new FormData();
      formData.append("carpeta", 10);
      formData.append("subCarpeta", id);
      formData.append("archivos", fileUpload);
      await setDatos(`atributos/archivos`, formData);
    } catch (err) {
      throw err;
    }
  };

  const saveImage = async (id) => {
    try {
      let formData = new FormData();
      formData.append("carpeta", 9);
      formData.append("subCarpeta", id);
      formData.append("archivos", imageUpload);
      await setDatos(`atributos/archivos`, formData);
    } catch (err) {
      throw err;
    }
  };

  const funcionGuardar = async (e) => {
    try {
      MySwal.fire({
        title: "Señor usuario",
        text: "¿Está seguro que desea continuar con el proceso?",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        customClass: {
          title: "sweet-alert-title-seguro",
          htmlContainer: "sweet-alert-container-seguro",
          confirmButton: "sweet-alert-confirm-button-seguro",
          cancelButton: "sweet-alert-cancel-button-seguro",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          saveNoticia(e);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const saveNoticia = async (e) => {
    const {
      nombreNoticia,
      descripcionNoticia,
      fechaNoticia,
      categoriaNoticia,
    } = dataNoticia;
    if (
      !nombreNoticia ||
      !descripcionNoticia ||
      !fechaNoticia ||
      !categoriaNoticia ||
      (!imageUpload && !objectEditarNoticia?.imagen)
    ) {
      // alert("Los campos marcados con * son obligatorios");
      Swal.fire({
        text: "Los campos marcados con * son obligatorios",
        icon: "warning",
        customClass: {
          htmlContainer: "sweet-alert-container",
          confirmButton: "sweet-alert-confirm-button",
        },
      });
      return;
    }

    try {
      handleLoad(true);
      if (accion === "Editar") {
        const { data: responseIds } = await updateDatos(
          `geomed/noticias/${dataNoticia.idNoticia}`,
          dataNoticia
        );
        const { idNoticia } = responseIds;

        if (imageUpload) {
          await saveImage(idNoticia);
        }
        if (fileUpload) {
          await saveFile(idNoticia);
        }
        MySwal.fire({
          title: "Se ha guardado correctamente",
          text: "El proceso se ha ejecutado de forma exitosa",
          confirmButtonText: "Aceptar",
          customClass: {
            title: "sweet-alert-title",
            htmlContainer: "sweet-alert-container",
            confirmButton: "sweet-alert-confirm-button",
          },
        });
        guardarGruposNuevo(idNoticia);
        buscar();
      } else {
        const { data: responseIds } = await setDatos(
          "geomed/noticias",
          dataNoticia
        );
        const { idNoticia } = responseIds;

        if (imageUpload) {
          await saveImage(idNoticia);
        }
        if (fileUpload) {
          await saveFile(idNoticia);
        }

        MySwal.fire({
          title: "Se ha guardado correctamente",
          text: "El proceso se ha ejecutado de forma exitosa",
          confirmButtonText: "Aceptar",
          customClass: {
            title: "sweet-alert-title",
            htmlContainer: "sweet-alert-container",
            confirmButton: "sweet-alert-confirm-button",
          },
        });

        guardarGruposNuevo(idNoticia);
        // alert("Registro guardado exitosamente");
      }
      handleLoad(false);
      onHide();
    } catch (error) {
      console.log("error", error);
      handleLoad(false);
      // alert("No se pudo registrar, vuelva a intentarlo");
    }
  };

  async function guardarGruposNuevo(idModulo) {
    let gruposUnificados = dataNoticia.grupos.concat(dataNoticia.subgrupos);
    const jsonGrupos = {
      id_modulo: idModulo,
      grupos: gruposUnificados.map((val) => val.value),
      modulo: "noticias",
    };
    const respuesta = await setDatosGrupos(`geomed/grupos/agregar`, jsonGrupos);
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      id="modalAdminRegister"
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{tituloModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="pb-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Titutlo de la noticia <strong>*</strong>
              </Form.Label>
              <Form.Control
                type="text"
                className="inputs-forms-admin focus-admin-register"
                name={"nombreNoticia"}
                onChange={handleChange}
                value={dataNoticia.nombreNoticia}
                maxLength={90}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Descripción <strong>*</strong>
              </Form.Label>
              <Form.Control
                as="textarea"
                className="inputs-forms-admin focus-admin-register textarea-form-admin"
                name={"descripcionNoticia"}
                onChange={handleChange}
                value={dataNoticia.descripcionNoticia}
              />
            </Form.Group>
            <DatePickerInput
              label={"Fecha de la noticia *"}
              fechaSeleccionada={
                dataNoticia.fechaNoticia ? dataNoticia.fechaNoticia : null
              }
              // fechaSeleccionada={''}
              onChangeDatePicker={handleDateChange}
            />
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Categoría <strong>*</strong>
              </Form.Label>
              <CategoriaNoticia
                caractFiltro={caractFiltro}
                handleChange={handleChange}
                nameCombo={"categoriaNoticia"}
                idCategoria={dataNoticia.categoriaNoticia}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">Grupo</Form.Label>
              <GruposSubgrupos
                caractFiltro={caractFiltro}
                handleChange={handleChangeGrupos}
                nombreCombo={"grupos"}
                tipoConsulta={"1"}
                tipofiltroSubGruposFiltrada={tipofiltroSubGruposFiltrada}
                datosEditar={dataNoticia.grupos}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">Subgrupo</Form.Label>
              <GruposSubgrupos
                caractFiltro={caractFiltro}
                handleChange={handleChangeGrupos}
                nombreCombo={"subgrupos"}
                tipoConsulta={"2"}
                tipofiltroSubGruposFiltrada={tipofiltroSubGruposFiltrada}
                datosEditar={dataNoticia.subgrupos}
              />
            </Form.Group>
            <DropZoneFile
              extensiones={{
                "image/png": [".png"],
                "image/svg": [".svg"],
                "image/jpeg": [".jpeg", ".jpg"],
              }}
              tipoFile={"Imagen *"}
              config={{
                icon: (
                  <AiOutlinePicture
                    color="#2E2E2E"
                    size={"25px"}
                    className="mb-2"
                  />
                ),
                message:
                  "Arrastre o de clic para subir la imagen (jpg, jpeg). Dimensiones 700px por 700px",
              }}
              onNewFile={handleImageUpload}
              rutaEdit={rutaImgImage}
              size={10}
            />
            <DropZoneFile
              extensiones={{
                "application/pdf": [],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                  [],
                "application/vnd.ms-excel": [],
                // "application/msword": [".doc", ".docx"],
                "application/zip": [".7z", ".rar"],
                "application/x-zip-compressed": [".zip"],
              }}
              config={{
                icon: (
                  <MdOutlineFileCopy
                    color="#2E2E2E"
                    size={"25px"}
                    className="mb-2"
                  />
                ),
                message:
                  "Arrastre o de clic para subir el archivo. (PDF, Excel, JPG, JPEG, .ZIP)",
              }}
              tipoFile={"Archivo"}
              onNewFile={handleFileUpload}
              rutaEdit={null}
              size={100}
            />
            <Form.Group className="mb-3">
              <div className="container-checks-admin">
                <Form.Label className="label-forms-admin me-2" title="Activo">
                  Activo
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"activoNoticia"}
                  onChange={handleChange}
                  checked={dataNoticia.activoNoticia}
                />

                <Form.Label
                  className="label-forms-admin me-2"
                  title="Destacado"
                >
                  Portada
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"destacadoNoticia"}
                  onChange={handleChange}
                  checked={dataNoticia.destacadoNoticia}
                />

                <Form.Label
                  className="label-forms-admin me-2"
                  title="Calificación"
                >
                  Calificación
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"calificacionNoticia"}
                  onChange={handleChange}
                  checked={dataNoticia.calificacionNoticia}
                />
              </div>
            </Form.Group>

            <div className="container-accion-admin-button ">
              <Button
                className="btn-geomedellin btn-register-admin btn-accion"
                onClick={funcionGuardar}
              >
                Guardar
              </Button>
            </div>
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
